module.exports = "/_next/static/images/FrameMobile-1e2deed2937e90116bafa3571afd28d6.png";